/**
 * Central configuration for every legal document.
 *
 * TODO(legal): replace every placeholder below with the reviewed, binding value.
 * Keeping them here means the legal team only has to edit one file, and the
 * values stay consistent across the Terms, Privacy Notice, Cookie Policy and
 * Accessibility Statement.
 */

// Human-readable platform name used across the documents.
export const PLATFORM_NAME = "RURACTIVE Decision Support Tool";

// Dates shown on every document.
export const LEGAL_LAST_UPDATED = "TODO: e.g. 14 October 2026";
export const LEGAL_EFFECTIVE_DATE = "TODO: date this version takes effect";

// Data controller (who is responsible for the personal data).
export const CONTROLLER_NAME = "TODO: legal entity name (data controller)";
export const CONTROLLER_ADDRESS = "TODO: registered address of the controller";
export const CONTROLLER_REGISTRATION = "TODO: company / registry number (if applicable)";

// Contacts.
export const PRIVACY_CONTACT_EMAIL = "TODO: privacy@example.org";
export const DPO_CONTACT =
  "TODO: name and contact details of the Data Protection Officer (if one is appointed)";

// Infrastructure / processing.
export const HOSTING_PROVIDER = "TODO: hosting provider and location of the servers";
export const RETENTION_PERIOD = "TODO: retention periods for each category of data";

// Third parties that may process personal data on behalf of the controller.
// NOTE: the wizard / assistant features send user-submitted content to an
// external Large Language Model service — this must be disclosed accurately.
export const PROCESSORS = [
  "TODO: Keycloak (self-hosted identity provider) — authentication and account data",
  "TODO: external Large Language Model provider (e.g. Google Gemini) — receives content submitted to the wizard/chat",
  "TODO: hosting / infrastructure provider",
];

// Regulatory references.
export const SUPERVISORY_AUTHORITY =
  "TODO: the competent supervisory authority and how to lodge a complaint";

// Accessibility statement specifics.
export const ACCESSIBILITY_FEEDBACK_EMAIL = "TODO: accessibility@example.org";
export const ACCESSIBILITY_ENFORCEMENT =
  "TODO: the national enforcement body and procedure for accessibility complaints";
